/**
 * "Ground answers in your content" — Guides section (ADR-0074).
 * Composes the knowledge flow: add sources → let them index → check coverage →
 * refine. Links to the canonical Knowledge page and AI transparency.
 */
import type { DocPageContent } from '../types';

export const GUIDES_GROUND_KNOWLEDGE_PAGE: DocPageContent = {
  slug: 'guides/ground-knowledge',
  titleKey: 'docs.guides.knowledge.title',
  descriptionKey: 'docs.guides.knowledge.description',
  blocks: [
    { kind: 'paragraph', textKey: 'docs.guides.knowledge.lead' },

    { kind: 'heading', level: 2, id: 'why', textKey: 'docs.guides.knowledge.why.heading' },
    { kind: 'paragraph', textKey: 'docs.guides.knowledge.why.body' },

    { kind: 'heading', level: 2, id: 'steps', textKey: 'docs.guides.knowledge.steps.heading' },
    {
      kind: 'steps',
      steps: [
        {
          titleKey: 'docs.guides.knowledge.step.add.title',
          textKey: 'docs.guides.knowledge.step.add.text',
        },
        {
          titleKey: 'docs.guides.knowledge.step.index.title',
          textKey: 'docs.guides.knowledge.step.index.text',
        },
        {
          titleKey: 'docs.guides.knowledge.step.test.title',
          textKey: 'docs.guides.knowledge.step.test.text',
        },
        {
          titleKey: 'docs.guides.knowledge.step.refine.title',
          textKey: 'docs.guides.knowledge.step.refine.text',
        },
      ],
    },
    {
      kind: 'callout',
      tone: 'tip',
      titleKey: 'docs.guides.knowledge.grounding.title',
      textKey: 'docs.guides.knowledge.grounding.body',
      links: {
        ai: { target: { docSlug: 'trust/ai' }, labelKey: 'docs.guides.knowledge.grounding.link' },
      },
    },

    { kind: 'heading', level: 2, id: 'next', textKey: 'docs.common.nextSteps' },
    {
      kind: 'cardGrid',
      cards: [
        {
          titleKey: 'docs.guides.knowledge.related.knowledge.title',
          textKey: 'docs.guides.knowledge.related.knowledge.text',
          to: { docSlug: 'dashboard/knowledge' },
        },
        {
          titleKey: 'docs.guides.knowledge.related.prompts.title',
          textKey: 'docs.guides.knowledge.related.prompts.text',
          to: { docSlug: 'dashboard/prompts' },
        },
      ],
    },
  ],
};
